import { DeleteAccountScreen } from "@/features/auth/screens/DeleteAccountScreen";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "@/utils/form";

const deleteAccountRouteSearchSchema = z.object({
    email: z.string().email().optional(),
});

export const Route = createFileRoute("/_auth/delete-account")({
    component: DeleteAccountScreen,
    validateSearch: (search) => deleteAccountRouteSearchSchema.parse(search),
});
